import { useRef } from 'react';
/**
 * Хук создает Ref, которая всегда указывает на актуальное значение
 * @param {T extends unknown} value
 */
export function useActualRef(value) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}